import "./app.scss";
import {
  Testimonial,
  Intro,
  About,
  Contact,
  Chat,
  Work,
  WhatIDoOne,
  WhatIDoTwo,
  WhatIDoThree,
} from "./Components/Index";

function App() {
  return (
    <div className="app">
      <div className="sections">
        <Intro />
        <div className='multi'>
          <WhatIDoOne />
          <WhatIDoTwo />
          <WhatIDoThree />
        </div>
        <Work />
        <div className='multi'>
          <About />
        </div>
        {/* <Contact /> */}
      </div>
    </div>
  );
}

export default App;
